import {combineReducers} from 'redux'
import isString from 'lodash/isString.js'

import INITIAL_STATE from '../INITIAL_STATE.js'
import parseHash from '../../../common/parseHash.js'

import {
  SET_LOCATION,
  SET_CURRENT_PAGE,
  SET_GLOBAL_ERROR,
  SET_API_LOCKED_LATCH,
  SET_ZUCK_COMPANY_ID,
  SET_ZUCK_SUPPRESS_APP_MESSAGE,
} from '../../actions/ui/index.js'

import dataImport from './dataImport/index.js'
import modals from './modals/index.js'
import forms from './forms.js'
import currentDropdown from './currentDropdown.js'
import dashboard from './dashboard.js'
import modal from './modal.js'

function isLocalhost(state = INITIAL_STATE.ui.isLocalhost) {
  return state
}

function currentPage(state = '', action = {}) {
  if (action.type === SET_CURRENT_PAGE) {
    return action.payload
  }

  return state
}

function globalError(state = INITIAL_STATE.ui.globalError, action = {}) {
  if (action.type === SET_GLOBAL_ERROR) {
    if (action.payload === null) {
      return {}
    } else if (isString(action.payload)) {
      // TODO: this won't be necessary once every call to the setGlobalError() action is updated
      return {
        summary: action.payload,
        details: null,
      }
    } else {
      return action.payload
    }
  }

  return state
}

function apiLockedLatch(state = INITIAL_STATE.ui.apiLockedLatch, action = {}) {
  if (action.type === SET_API_LOCKED_LATCH) {
    return action.payload
  }

  return state
}

function zuckCompanyID(state = INITIAL_STATE.ui.zuckCompanyID, action = {}) {
  if (action.type === SET_ZUCK_COMPANY_ID) {
    return Number(action.payload) || INITIAL_STATE.ui.zuckCompanyID
  }

  return state
}

function zuckSuppressAppMessage(
  state = INITIAL_STATE.ui.zuckSuppressAppMessage,
  action = {},
) {
  if (action.type === SET_ZUCK_SUPPRESS_APP_MESSAGE) {
    return Number(action.payload) || INITIAL_STATE.ui.zuckSuppressAppMessage
  }

  return state
}

function location(state = parseHash(window.location.hash), action = {}) {
  if (action.type === SET_LOCATION) {
    return action.payload
  }

  return state
}

export default combineReducers({
  isLocalhost,
  currentDropdown,
  currentPage,
  globalError,
  apiLockedLatch,
  zuckCompanyID,
  zuckSuppressAppMessage,
  dataImport,
  modals,
  forms,
  dashboard,
  modal,
  location,
})
